import React from 'react';
import doowopImage from '../images/DOOWOP_ALLSTAR_2026_NEWFINAL_1770419162213.JPG';

function Event2() {
  return (
    <div>
      {/* Event Hero */}
      <section className="event-hero">
        <div className="hero-content">
          <p className="hero-subtitle">Saturday, February 15, 2026</p>
          <div style={{display: 'flex', justifyContent: 'center', margin: '2rem 0'}}>
            <a href="https://www.tixr.com/groups/headliner/events/doo-wop-all-star-2026-edition-176152" target="_blank" rel="noopener noreferrer">
              <img
                src={doowopImage}
                alt="Doo-Wop: Love & Basketball Edition"
                style={{maxWidth: '40%', width: '100%', height: 'auto', borderRadius: '8px', cursor: 'pointer'}}
              />
            </a>
          </div>
          <p className="hero-description" style={{textAlign: 'center'}}>
            <strong>NBA All-Star Weekend Valentine's Celebration</strong><br/>
            Love & Basketball: A Lovers & Ballers Doo-Wop Experience<br/><br/>

            Doo-Wop All-Star 2026 Edition<br/>
            📍 Academy LA | Saturday, February 14, 2026<br/><br/>

            Close your eyes and step into the ultimate Doo-Wop experience as NBA All-Star Weekend 2026 meets Valentine's Day at Academy LA.<br/><br/>

            Love & Basketball: A Lovers & Ballers Valentine's is a night dedicated to timeless R&B, classic soul, and unforgettable energy. From smooth slow jams to sing-along anthems, every record played is designed to take you back while keeping the dance floor alive all night long.<br/><br/>

            This is more than a party — it's a feeling.<br/>
            A space for lovers, friends, and ballers to connect, vibe, and celebrate All-Star Weekend with style.<br/><br/>

            This party isn't for everybody…<br/>
            but everybody is welcome.<br/><br/>

            <strong>EVENT HIGHLIGHTS</strong><br/>
            NBA All-Star Weekend 2026 Official Valentine's Celebration<br/>
            Doo-Wop Edition: Classic R&B & Soul All Night<br/>
            Lovers & Ballers Valentine's Experience<br/>
            High-energy crowd with timeless vibes<br/>
            Premium nightlife experience at Academy LA<br/>
            Perfect pre- or post-game All-Star Weekend destination<br/>
            Early arrival strongly recommended<br/><br/>

            <strong>🎟️ TICKETS & ADMISSION</strong><br/>
            Cupid's Special (Ladies Free)<br/>
            FREE (Limited availability)<br/><br/>

            Early Bird Tickets<br/>
            Lovers & Ballers Early Bird General Admission – $30 + fees<br/>
            Heart & Hustle Early Bird Skip-the-Line – $50 + fees<br/><br/>

            🚨 Skip-the-Line tickets provide expedited entry but do not include table seating.<br/><br/>

            <strong>TABLES & VIP EXPERIENCE</strong><br/>
            Table reservations offer the ultimate experience, including:<br/>
            Premium seating<br/>
            Bottle service<br/>
            Personalized VIP attention<br/>
            Best views and fastest entry<br/>
            Highly recommended for groups celebrating Valentine's Day or All-Star Weekend in style.<br/><br/>

            <strong>DRESS CODE</strong><br/>
            Chic & Stylish<br/>
            Dress to impress — fashionable, elevated, and camera-ready.<br/><br/>

            <strong>CONTACT & INQUIRIES</strong><br/>
            For table reservations, press/media, or general information, please contact:<br/>
            📧 info@supremeteamla.com
          </p>
        </div>
      </section>

      {/* Event Details */}
      {/* <section className="event-details">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Event Details</h2>
          </div>

          <div className="event-info-grid">
            <div className="info-box">
              <div className="info-label">Date & Time</div>
              <div className="info-value">Saturday, February 14, 2026<br/>9:30 PM</div>
            </div>

            <div className="info-box">
              <div className="info-label">Duration</div>
              <div className="info-value">Approximately 75 minutes</div>
            </div>

            <div className="info-box">
              <div className="info-label">Participants</div>
              <div className="info-value">4 High-Flying Athletes</div>
            </div>

            <div className="info-box">
              <div className="info-label">Prize</div>
              <div className="info-value">$100,000 Champion</div>
            </div>
          </div>
        </div>
      </section> */}

      {/* About Section */}
      <section className="section">
        <div className="container">
          {/* <div className="section-header">
            <h2 className="section-title">About The Contest</h2>
          </div> */}

          <div style={{maxWidth: '900px', margin: '0 auto'}}>
            {/* <p style={{color: 'var(--light-gray)', fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '1.5rem'}}>
              The Slam Dunk Contest is basketball's most spectacular showcase of athleticism and creativity. Four of the NBA's most explosive dunkers compete in a two-round format, each attempting to create unforgettable moments that will be replayed for generations.
            </p> */}

            {/* <p style={{color: 'var(--light-gray)', fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '1.5rem'}}>
              Dunkers have multiple attempts to execute their dunks perfectly, combining power, style, and innovation. From 360-degree spins to off-the-backboard alley-oops, from jumping over props to incorporating teammates, each participant brings their unique style and creativity to the court.
            </p> */}

            {/* <p style={{color: 'var(--light-gray)', fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '2rem'}}>
              Five judges score each dunk on a scale of 6-10, with a perfect 50 representing dunk perfection. The two highest scorers from the first round advance to the finals, where they battle head-to-head for the championship and eternal glory.
            </p> */}

            <div style={{textAlign: 'center', marginTop: '3rem'}}>
              <a href="https://www.tixr.com/groups/headliner/events/doo-wop-all-star-2026-edition-176152" target="_blank" rel="noopener noreferrer" className="btn btn-primary">Get Tickets</a>
            </div>
          </div>
        </div>
      </section>

      {/* Judging Criteria */}
      {/* <section className="section" style={{background: 'var(--dark-gray)'}}>
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">What Makes A Perfect Dunk</h2>
          </div>

          <div className="events-grid">
            <div className="event-card" style={{cursor: 'default'}}>
              <span className="event-number">10</span>
              <h3>Creativity</h3>
              <p>
                Originality and innovation in approach. Has this been done before? What unique elements make this dunk memorable? The most creative dunks often become instant classics.
              </p>
            </div>

            <div className="event-card" style={{cursor: 'default'}}>
              <span className="event-number">10</span>
              <h3>Athleticism</h3>
              <p>
                Raw power, vertical leap, and body control. The difficulty of the dunk relative to human physical capabilities. Judges look for displays of extraordinary athletic ability.
              </p>
            </div>

            <div className="event-card" style={{cursor: 'default'}}>
              <span className="event-number">10</span>
              <h3>Execution</h3>
              <p>
                Clean finish and style points. How well was the dunk executed? Smooth landings and confident delivery elevate a good dunk to greatness.
              </p>
            </div>

            <div className="event-card" style={{cursor: 'default'}}>
              <span className="event-number">10</span>
              <h3>Overall Impact</h3>
              <p>
                The "wow factor" that makes crowds erupt. Some dunks transcend technical scoring and create moments that define careers. This is where legends are born.
              </p>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
}

export default Event2;
